import React from 'react';
import Box from '@mui/material/Box';

export default ({ sx, color, ...props }) => {
  const size = sx?.fontSize || props.fontSize || "2.5rem";
  return (
    <Box
      component="img"
      src="/img/aguapotablelogo.png"
      alt="Logo"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        ...sx,
        fontSize: undefined
      }}
      {...props}
    />
  );
};
